import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { notFoundResponse, removedResponse, updatedResponse } from '../../routes/defaultResponses';
import { makeNullable } from '../../utils/typeboxHelpers';

export const fmecaFurtherInvestigationPaths = {
    '/api/surveys/{surveyId}/fmecaFurtherInvestigations': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'fmecaFurtherInvestigationControllers.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Intersect([
                                    Type.Object({
                                        description: Type.String(),
                                        id: Type.String(),
                                        priority: Type.Number(),
                                        failureModeId: makeNullable(Type.String()),
                                    }),
                                    Type.Object({
                                        unit: Type.Object({
                                            name: Type.String(),
                                            element: Type.Object({
                                                name: Type.String(),
                                            }),
                                        }),
                                        manifestation: Type.Object({
                                            name: makeNullable(Type.String()),
                                        }),
                                    }),
                                ]),
                            ),
                        },
                    },
                },
            },
            parameters: [
                { name: 'unitId', in: 'query', schema: Type.String() },
                { name: 'manifestationId', in: 'query', schema: Type.String() },
                { name: 'failureModeId', in: 'query', schema: Type.String() },
            ],
        },
        post: {
            operationId: 'fmecaFurtherInvestigationControllers.create',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            description: Type.String(),
                            priority: Type.Number(),
                            failureModeId: makeNullable(Type.String({ format: 'uuid' })),
                        }),
                    },
                },
            },
            parameters: [
                { name: 'unitId', in: 'query', schema: Type.String() },
                { name: 'failureModeId', in: 'query', schema: Type.String() },
                { name: 'manifestationId', in: 'query', schema: Type.String() },
            ],
        },
    },
    '/api/surveys/{surveyId}/fmecaFurtherInvestigations/{fmecaFurtherInvestigationId}': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('fmecaFurtherInvestigationId')],
        get: {
            operationId: 'fmecaFurtherInvestigationControllers.getOne',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Intersect([
                                Type.Object({
                                    description: Type.String(),
                                }),
                                Type.Object({
                                    id: Type.String(),
                                }),
                                Type.Object({
                                    priority: Type.Number(),
                                }),
                                Type.Object({
                                    failureModeId: makeNullable(Type.String()),
                                }),
                            ]),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'fmecaFurtherInvestigationControllers.update',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            description: Type.String(),
                            priority: Type.Number(),
                            failureModeId: makeNullable(Type.String({ format: 'uuid' })),
                        }),
                    },
                },
            },
            responses: {
                ...updatedResponse,
                ...notFoundResponse,
            },
        },
        delete: {
            operationId: 'fmecaFurtherInvestigationControllers.remove',
            responses: {
                ...removedResponse,
                ...notFoundResponse,
            },
        },
    },
} as const;
